module.exports = __webpack_public_path__ + "static/media/cscc-5.28e6e7c4.jpg";